import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

import { Box, IconButton, Button, Typography, Tooltip } from "@mui/material";
import { KeyboardBackspace, Settings } from "@mui/icons-material";
import AlertModal from "../alertModal";
import { Row, Col } from "react-bootstrap";
import { PostSettings } from "./postSetting";
import { getEntityCategories } from "./postHelpers";

const getTargetVid = (typeName) => {
  switch (typeName) {
    case "news":
      return "news_categories";
    case "event":
      return "event_categories";
    case "presentation":
      return "presentation_categories";
    case "video":
      return "video_categories";
    case "gallery":
      return "gallery_categories";
    case "podcast":
      return "podcast_categories";
    case "document":
      return "document_categories";
    case "training":
      return "training_categories";
    case "quiz":
      return "quiz_categories";
    case "link":
      return "link_categories";
    default:
      return null;
  }
};

export default function PostEditToolbar(props) {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [categories, setCategories] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [sitas, setSitas] = useState([]);
  const [references, setReferences] = useState([]);
  const navigate = useNavigate();
  const user = useSelector((state) => state.authReducer.user);

  useEffect(() => {
    getEntityCategories({
      user,
      setCategories,
      setLanguages,
      setSitas,
      setReferences,
      targetVid: getTargetVid(props.entityType),
    });
  }, [user, props.entityType]);

  return (
    <Box className="post-edit-toolbar d-flex flex-row justify-content-between align-items-center py-3 px-0">
      <Box className="post-edit-toolbar-left">
        <Row className="gx-3">
          <Col xs={"auto"}>
            <Tooltip title={props.backBtnText ?? ""}>
              <Box className="d-flex align-items-center flex-row">
                <Button
                  className="px-1"
                  onClick={() => {
                    navigate(props.route);
                  }}
                  startIcon={
                    <IconButton
                      className="post-edit-icon-btn back-btn d-flex align-items-center"
                      variant="circular"
                      owner="admin"
                      color="white"
                      size="small"
                    >
                      <KeyboardBackspace />
                    </IconButton>
                  }
                >
                  <Typography
                    variant="button"
                    color="adminText.dark"
                    textTransform={"none"}
                  >
                    Back
                  </Typography>
                </Button>
              </Box>
            </Tooltip>
          </Col>
          <Col>
            <Box className="d-flex align-items-center">
              <Button
                className="px-1"
                startIcon={
                  <IconButton
                    className="post-edit-icon-btn settings-btn d-flex align-items-center"
                    variant="circular"
                    owner="admin"
                    color="white"
                    size="small"
                  >
                    <Settings />
                  </IconButton>
                }
                onClick={() => setSettingsOpen(true)}
              >
                <Typography
                  variant="button"
                  color="adminText.dark"
                  textTransform={"none"}
                >
                  Settings
                </Typography>
              </Button>
            </Box>
          </Col>
        </Row>
      </Box>
      <Box className="post-edit-toolbar-right">
        <Row>
          <Col xs="auto">
            <Button
              className="px-1 mx-0"
              variant="outlined"
              owner="admin"
              dialogbtn="true"
              dialogvariant="cancel"
              onClick={() => setShowAlert(true)}
            >
              <Typography owner="admin" variant="button" className="lh">
                Revert
              </Typography>
            </Button>
          </Col>
          <Col xs="auto">
            <Button
              className="px-1 mx-0"
              variant="contained"
              owner="admin"
              dialogbtn="true"
              dialogvariant="primary"
              onClick={() => window.open(props.previewRoute, "_blank")}
            >
              <Typography owner="admin" variant="button" className="lh">
                Preview
              </Typography>
            </Button>
          </Col>
        </Row>
      </Box>
      <AlertModal
        showAlert={showAlert}
        showCaLogo={true}
        alertType={"warning"}
        alertMessageTitle={"Are you sure"}
        alertMessageBody={"Revert changes?"}
        cancelButton={true}
        cancelButtonLabel={"Cancel"}
        confirmButton={true}
        confirmButtonLabel={"Revert"}
        confirmButtonColor={"error"}
        showAlertCallback={() => setShowAlert(false)}
        onConfirm={() => props.revertChanges()}
      />
      <PostSettings
        open={settingsOpen}
        onClose={() => {
          setSettingsOpen(false);
        }}
        categories={categories}
        references={references}
        sitas={sitas}
        languages={languages}
        user={user}
        disableReactions={props.disableReactions}
        disableComments={props.disableComments}
        onSaveSuccess={() => {
          if (props.getContent) {
            props.getContent();
          }
        }}
        activeGridItem={props?.post}
        entityType={props.entityType}
        persistOnSave={true}
      />
    </Box>
  );
}
